import { render, staticRenderFns } from "./ProductQuickViewVertical.vue?vue&type=template&id=d395d4dc&scoped=true"
import script from "./ProductQuickViewVertical.vue?vue&type=script&lang=js"
export * from "./ProductQuickViewVertical.vue?vue&type=script&lang=js"
import style0 from "./ProductQuickViewVertical.vue?vue&type=style&index=0&id=d395d4dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d395d4dc",
  null
  
)

export default component.exports